module.exports = __webpack_public_path__ + "img/singapore-featured-image-400x263.a37669f3.jpg";